"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var LayoutUtils = /** @class */ (function () {
    function LayoutUtils() {
    }
    LayoutUtils.uniqueId = function () {
        return 'xxxxxxxx'.replace(/[xy]/g, function (c) {
            // tslint:disable:no-bitwise
            var r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
            // tslint:enable:no-bitwise
            return v.toString(16);
        });
    };
    LayoutUtils.multiLingualToJson = function (multiString) {
        var obj = {};
        multiString
            .toMap()
            .forEach(function (value, key) { return (obj[key] = value); });
        return obj;
    };
    LayoutUtils.getMultiLingualText = function (customText) {
        var multilingualStringBuilder = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
        if (customText) {
            Object.keys(customText).map(function (key) {
                multilingualStringBuilder.withValueForLanguage(Number(key), customText[key]);
            });
        }
        return multilingualStringBuilder.build();
    };
    LayoutUtils.scrollUp = function (designerContext) {
        if (!designerContext.scrollIntervalId) {
            designerContext.scrollIntervalId = setInterval(function () {
                return designerContext.scrollElement.nativeElement.scrollBy(0, -2);
            }, 1);
        }
    };
    LayoutUtils.scrollDown = function (designerContext) {
        if (!designerContext.scrollIntervalId) {
            designerContext.scrollIntervalId = setInterval(function () {
                return designerContext.scrollElement.nativeElement.scrollBy(0, 2);
            }, 1);
        }
    };
    LayoutUtils.stopScrolling = function (designerContext) {
        if (designerContext.scrollIntervalId) {
            clearInterval(designerContext.scrollIntervalId);
            designerContext.scrollIntervalId = undefined;
        }
    };
    return LayoutUtils;
}());
exports.LayoutUtils = LayoutUtils;
//# sourceMappingURL=layout-utils.js.map